import { selectBuildingConstructionInProgress } from "../../../../selectors/selectBuildingConstructionInProgress";
export var checkBuildingPurchaseIsConstructionInProgress = function (path) { return function (action, state$) {
    var state = state$.value;
    var constructionInProgress = selectBuildingConstructionInProgress(state);
    if (constructionInProgress) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingPurchaseIsConstructionInProgress.ts
// module id = 2064
// module chunks = 3